import { Typography, useTheme } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { differenceInDays, fromUnixTime } from 'date-fns';
import React from 'react';
import { AccessKeyExpiration, AccessKeyStatus } from 'types/accessKeys';
import { ITheme } from 'types/theme';

const EXPIRATION_LEVELS = {
	RISK: 10,
	WARNING: 30
};

const ExpirationCell: React.FC<GridRenderCellParams<string>> = ({
	value,
	row
}) => {
	const theme = useTheme<ITheme>();

	let display = value;
	let color = theme.palette.text.default;

	if (!row.expireTime) {
		display = intl.tr(`accessKeys.expiration.${AccessKeyExpiration.never}`);
	} else {
		display = intl.formatDateTime(value);

		if (row.status === AccessKeyStatus.inactive) {
			color = theme.palette.text.disabled;
		} else {
			// get today in unix time
			const today = Date.now();
			const daysDiff = differenceInDays(fromUnixTime(row.expireTime), today);

			if (
				EXPIRATION_LEVELS.RISK <= daysDiff &&
				daysDiff <= EXPIRATION_LEVELS.WARNING
			) {
				color = theme.palette.warning.main;
			} else if (daysDiff < EXPIRATION_LEVELS.RISK) {
				color = theme.palette.error.main;
			}
		}
	}

	return (
		<Typography
			color={color}
			title={display}
			data-testid="expiration-cell"
			variant="body2"
		>
			{display}
		</Typography>
	);
};

export default ExpirationCell;
